import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgCloseRegular24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Close",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.242 4.213a.727.727 0 0 0-1.029 1.029L10.972 12l-6.759 6.759a.727.727 0 1 0 1.029 1.028L12 13.029l6.759 6.758a.727.727 0 0 0 1.028-1.028L13.029 12l6.758-6.758a.727.727 0 0 0-1.028-1.029L12 10.972z",
  clipRule: "evenodd"
}));

export { SvgCloseRegular24 as default };
//# sourceMappingURL=CloseRegular24.js.map
